<mat-card class="mat-card-user-detail">
  <mat-card-header>
    <mat-card-title>{{ 'label.site-mode' | translate }}</mat-card-title>
    <mat-card-subtitle *ngIf="!data?.id">{{ 'label.creation' | translate }}</mat-card-subtitle>
    <mat-card-subtitle *ngIf="data?.id">{{ 'label.edition' | translate }}</mat-card-subtitle>
  </mat-card-header>
  <form [formGroup]="siteModeForm" (ngSubmit)="onSubmit()">
    <mat-card-content>
      <div class="content-row">
        <label class="content-row-label">{{ 'label.name' | translate }}</label>
        <mat-form-field class="content-row-input">
          <input matInput formControlName="name" type="text" autocomplete="off">
        </mat-form-field>
      </div>
    </mat-card-content>
    <mat-card-actions class="report-error-card-action">
      <button mat-raised-button color="warn" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon> {{ 'button.cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="siteModeForm.invalid">
        <mat-icon>save</mat-icon> {{ 'button.save' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>